<h1>{{title}}</h1>
<form *ngIf="!loading" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
        <input type="hidden" formControlName="id">
        <div class="col-md-6 mb-3">
            <label class="form-label">Email</label>
            <input type="text" formControlName="email" class="form-control" />
            <div *ngIf="form.get('email').invalid && (form.get('email').dirty || form.get('email').touched)"
                class="text-danger">
                <div *ngIf="form.get('email').errors.required">
                    Email is required.
                </div>
                <div *ngIf="form.get('email').errors.pattern">
                    Please enter a valid email address.
                </div>
            </div>
        </div>
        <div class="col-md-6 mb-3">
            <label class="form-label">Host</label>
            <input type="text" formControlName="host" class="form-control" />
            <div *ngIf="form.get('host').invalid && (form.get('host').dirty || form.get('host').touched)"
                class="text-danger">
                <div *ngIf="form.get('host').errors.required">
                    Host is required.
                </div>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label class="form-label">User Name</label>
            <input type="text" formControlName="userName" class="form-control" />
            <div *ngIf="form.get('userName').invalid && (form.get('userName').dirty || form.get('userName').touched)"
                class="text-danger">
                <div *ngIf="form.get('userName').errors.required">
                    Email is required.
                </div>
                <div *ngIf="form.get('userName').errors.pattern">
                    Please enter a valid email address.
                </div>
            </div>
        </div>
        <div class="col-md-6 mb-3">
            <label class="form-label">Password</label>
            <input type="text" formControlName="password" class="form-control" />
            <div *ngIf="form.get('password').invalid && (form.get('password').dirty || form.get('password').touched)"
                class="text-danger">
                <div *ngIf="form.get('password').errors.required">
                    password is required.
                </div>

            </div>
        </div>
        <div class="col-md-6 mb-3">
            <label class="form-label">Port</label>
            <input type="text" formControlName="port" class="form-control" />
            <div *ngIf="form.get('port').invalid && (form.get('port').dirty || form.get('port').touched)"
                class="text-danger">
                <div *ngIf="form.get('port').errors.required">
                    Port is required.
                </div>

            </div>
        </div>
        <div class="col-md-6 mb-3">
            <!-- <label class="form-label">EnableSSl</label> -->
            <input type="checkbox" formControlName="enableSSl"> EnableSSl
        </div>
        <div class="col-md-6 mb-3">
            <!-- <label class="form-label">EnableSSl</label> -->
            <input type="checkbox" formControlName="defaultEmail"> defaultEmail
        </div>

    </div>


    <div class="form-group">
        <button type="button" (click)="onSubmit()" class="btn btn-primary" [disabled]="isLoading$ | async">
            <span *ngIf="!isAuthLoading">submit</span>
            <span *ngIf="isAuthLoading">Submitting...</span>
            <img *ngIf="isLoading$ | async" src="assets/img/loader.gif" alt="Loading..." class="loader-image mt-2">
        </button>
        <button type="button" class="btn btn-primary ml-2" (click)="showDialog()">Send Test Mail</button>

    </div>
</form>
<p-dialog header="Enter Test Mail" [modal]="true" [(visible)]="sendTestMailVisible" [style]="{ width: '50rem' }">
    <app-send-test-mail></app-send-test-mail>
</p-dialog>
